import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { User } from '../types';
import type { DataAction } from '../../../types/dataAction.type';

const UpdateUser = new ReduxAsyncAction<'UPDATE_USER', any, User>('UPDATE_USER');

UpdateUser.registerRequest(function (body) {
  return dash_api.patch(`/v1/dashboard-user`, body).then((res) => {
    return res.data;
  });
});

export const UPDATE_USER = UpdateUser.actionNamespaceConstants;

export const updateUser = UpdateUser.request;

export type UpdateUserResponseAction = DataAction<typeof UPDATE_USER.response, User>;
